export const SIGN_UP_PATH = "sign-up";
